<script lang="ts">
  import type { Snippet } from "svelte";
  import DotPatternBackground from "./DotPatternBackground.svelte";

  interface Props {
    children: Snippet;
    showBackground?: boolean;
  }

  const { children, showBackground = true }: Props = $props();
</script>

<div
  class="relative flex min-h-screen w-screen justify-center overflow-x-hidden bg-mono-000 font-sans antialiased dark:bg-mono-100"
>
  {#if showBackground}
    <DotPatternBackground />
  {/if}
  <div class="z-10 flex w-full flex-col items-center gap-3 text-sm text-foreground-tertiary">
    {@render children()}
  </div>
</div>
